<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useSessionStore } from './stores/session.js';
const session = useSessionStore();
const router = useRouter();
onMounted(async () => {
  await session.load();
  if (!session.authenticated && router.currentRoute.value.path !== '/login')
    await router.replace('/login');
  if (session.authenticated && router.currentRoute.value.path === '/login')
    await router.replace('/');
  if (router.currentRoute.value.meta.admin && !session.isSuperadmin) await router.replace('/');
});
</script>

<template>
  <div v-if="session.loading" class="loading-screen"><div class="brand-mark">C</div></div>
  <template v-else-if="!session.authenticated"><router-view /></template>
  <div v-else class="app-shell">
    <aside class="sidebar">
      <router-link to="/" class="logo"
        ><span class="brand-mark small">C</span><strong>Calloneer</strong></router-link
      >
      <nav>
        <router-link to="/">Dialer</router-link><router-link to="/history">History</router-link
        ><router-link to="/usage">Usage</router-link
        ><router-link to="/settings">Settings</router-link
        ><router-link v-if="session.isSuperadmin" to="/admin">Administration</router-link>
      </nav>
      <div class="account">
        <img
          v-if="session.user?.avatarUrl"
          :src="session.user.avatarUrl"
          alt=""
          referrerpolicy="no-referrer"
        />
        <div>
          <strong>{{ session.user?.displayName }}</strong
          ><span>{{ session.user?.email }}</span>
        </div>
        <button class="text-button" @click="session.logout">Sign out</button>
      </div>
    </aside>
    <main class="content"><router-view /></main>
  </div>
</template>
